export default function GlowCard({ children, className = "", testid }) {
  const onMove = (e) => {
    const r = e.currentTarget.getBoundingClientRect();
    e.currentTarget.style.setProperty("--mouse-x", `${e.clientX - r.left}px`);
    e.currentTarget.style.setProperty("--mouse-y", `${e.clientY - r.top}px`);
  };
  return (
    <div onMouseMove={onMove} className={`glow-card rounded-lg p-7 ${className}`} data-testid={testid}>
      {children}
    </div>
  );
}
